<template>
  <el-dialog
    :title="$t('deleteJob.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div style="text-align:center">
      <p>{{ $t('deleteJob.confirmDeleteTask') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('deleteJob.cancel') }}</el-button>
      <el-button type="primary" @click="deleteJob">{{ $t('deleteJob.confirmDelete') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteTask } from '@/api/dev/jobApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteJob',
  data() {
    return {
      dialogVisible: false,
      deleteJobInfo: {
        taskId: ''
      }
    }
  },
  methods: {
    open(job) {
      this.dialogVisible = true
      this.deleteJobInfo.taskId = job.taskId
    },
    handleClose() {
      this.deleteJobInfo = {
        taskId: ''
      }
    },
    async deleteJob() {
      try {
        const params = {
          ...this.deleteJobInfo,
          shopId: getShopId()
        }
        await deleteTask(params)
        this.$message.success(this.$t('deleteJob.deleteSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error('删除任务失败:', error)
      }
    }
  }
}
</script>